<mat-card>
    <mat-card-header>
        <mat-card-title>Workspace Name</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="workspaceGroup" (ngSubmit)="updateWorkspaceName()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>New Name</mat-label>
                <input matInput type="text" [formControl]="workspaceGroup.controls.nameControl">
                <mat-error *ngIf="workspaceGroup.controls.nameControl.invalid">{{getErrorName()}}</mat-error>
            </mat-form-field>
            <mat-card-actions>
                <button mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!workspaceGroup.valid" color="accent">Update</button>
                <button mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>